<template>
  <v-img
    class="hs"
    :src="iconSource"
    contain
    @click="clicked"
    :style="styling"
  />
</template>
<script>

const DEFAULT_HOTSPOT_SIZE_WITH_TITLE = 28;
const DEFAULT_HOTSPOT_SIZE = 37;
const DEFAULT_HOTSPOT_TITLE_SIZE = 8;
const BROWSER_SIZE_OFFSET = 505;

export default {
  name: 'hotspot',
  props: {
    hs: {
      type: Object,
      required: true,
    },
    top: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },

  },
  data() {
    return {};
  },
  computed: {
    styling() {
      // Calculate browser size offset
      const sizeOffset = this.height / BROWSER_SIZE_OFFSET;
      // Calculate icon size. Smaller on small screen and larger on large screen. DOH!
      const width = this.hs.customText
        ? sizeOffset * (DEFAULT_HOTSPOT_SIZE_WITH_TITLE * this.hs.scale)
        : sizeOffset * (DEFAULT_HOTSPOT_SIZE * this.hs.scale);
      const height = this.hs.customText
        ? sizeOffset * (DEFAULT_HOTSPOT_SIZE_WITH_TITLE * this.hs.scale)
        : sizeOffset * (DEFAULT_HOTSPOT_SIZE * this.hs.scale);

      // Add height offset if hotspot has title
      const heightOffset = this.hs.customText
        ? DEFAULT_HOTSPOT_TITLE_SIZE * this.hs.scale * sizeOffset
        : sizeOffset;

      const yaw = Number(this.hs.rotation.yaw);
      const pitch = Number(this.hs.rotation.pitch);

      // Calculate icon position
      const x = this.left + (yaw * this.width);
      const y = this.top + (pitch * this.height);

      return {
        marginTop: `-${(height + heightOffset) / 2}px`,
        marginLeft: `-${width / 2}px`,
        width: `${width}px`,
        height: `${height}px`,
        left: `${x}px`,
        top: `${y}px`,
      };
    },
    iconSource() {
      const iconSet = this.hs.customSetName || 'hotspot_00_Default';
      const extension = this.hs.customSetName ? '' : '.png';
      return `/${iconSet}/${this.hs.fileName}${extension}`;
    },
  },
  methods: {
    clicked() {
      if (this.hs.hotspotType === 3) {
        if (this.hs.actionURL.includes('http://') || this.hs.actionURL.includes('https://')) {
          window.open(this.hs.actionURL, 'eSiteExternal');
        } else {
          window.open(`https://${this.hs.actionURL}`, 'eSiteExternal');
        }
      } else {
        this.$store.commit('customText', this.hs.customText);
        this.$store.commit('hotspotDescription', this.hs.hotspotDescription);
        this.$store.commit('currentHotspot', this.hs);
      }
      this.$player.pause();
    },
  },
};
</script>

<style scoped>
.hs {
  cursor: pointer;
  position: fixed;
}
</style>
